"use strict";
const UNDPColorModule = {
    graphBackgroundColor: '#F7F7F7',
    graphMainColor: '#006EB5',
    graphGray: '#D4D6D8',
    graphNoData: '#FFFFFF',
    categoricalColors: {
        colors: ['#006eb5', '#5DD4F0', '#02A38A', '#E78625', '#E0529E', '#FC6932', '#757AF0', '#A0C236', '#FBC412', '#746960'],
        genderColors: {
            male: '#02A38A',
            female: '#757AF0',
        },
        locationColors: {
            urban: '#006eb5',
            rural: '#5DD4F0',
        }
    },
    sequentialColors: {
        negativeColorsx04: ['#F6B666', '#EB8033', '#D64513', '#A71C04'],
        negativeColorsx05: ['#FBD68A', '#F39E4B', '#E16424', '#C12705', '#850E02'],
        negativeColorsx06: ['#FFF4AC', '#F7BD6D', '#EC8234', '#D54211', '#A01903', '#650000'],
        negativeColorsx07: ['#FFF4AC', '#F8C678', '#F29641', '#E16424', '#C92B06', '#961503', '#650000'],
        negativeColorsx08: ['#FFF4AC', '#F9CD7F', '#F4A451', '#E97A30', '#D94C17', '#BB2505', '#8F1202', '#650000'],
        negativeColorsx09: ['#FFF4AC', '#FAD285', '#F5AE5D', '#EE8938', '#E16424', '#D2390C', '#ad190d', '#891002', '#650000'],
        negativeColorsx10: ['#FFF4AC', '#FBD68A', '#F6B666', '#F29641', '#E7752D', '#DB521A', '#C92B06', '#A71C04', '#850E02', '#650000'],
        positiveColorsx04: ['#BADA81', '#7FC45F', '#58A85A', '#308C56'],
        positiveColorsx05: ['#DDE797', '#9FD071', '#6CB65D', '#429858', '#187B54'],
        positiveColorsx06: ['#FFF4AC', '#C1DD85', '#81C55F', '#56A75A', '#2C8956', '#006A51'],
        positiveColorsx07: ['#FFF4AC', '#CBE18C', '#96CD6B', '#6CB65D', '#489D59', '#248455', '#006A51'],
        positiveColorsx08: ['#FFF4AC', '#D3E491', '#A6D374', '#7BC05E', '#5CAB5B', '#3E9558', '#1F8054', '#006A51'],
        positiveColorsx09: ['#FFF4AC', '#D8E694', '#B1D77C', '#88C862', '#6CB65D', '#51A35A', '#369057', '#1B7D54', '#006A51'],
        positiveColorsx10: ['#FFF4AC', '#DDE797', '#BADA81', '#96CD6B', '#78BE5E', '#60AD5B', '#489D59', '#308C56', '#187B54', '#006A51'],
        neutralColorsx04: ['#5CCEE1', '#0087C1', '#0087C1', '#0064AA'],
        neutralColorsx05: ['#89E0E8', '#37BFDB', '#0099CA', '#0073B8', '#005195'],
        neutralColorsx06: ['#B5F2EF', '#65D2E2', '#0CAED4', '#0086C1', '#0061A6', '#003F80'],
        neutralColorsx07: ['#B5F2EF', '#73D7E4', '#2BBAD9', '#009ACB', '#0079BA', '#005B9F', '#003F80'],
        neutralColorsx08: ['#B5F2EF', '#7DDBE6', '#40C3DC', '#00A8D2', '#008CC4', '#0070B6', '#00579B', '#003F80'],
        neutralColorsx09: ['#B5F2EF', '#84DEE7', '#50C9DF', '#18B2D6', '#009ACB', '#0081BE', '#0069B0', '#005497', '#003F80'],
        neutralColorsx10: ['#B5F2EF', '#89E0E8', '#5CCEE1', '#2BBAD9', '#00A5D0', '#008FC5', '#0079BA', '#0064AA', '#005195', '#003F80'],
    },
    divergentColors: {
        colorsx04: ['#F34C36', '#FAA89D', '#82C5D6', '#008FB4'],
        colorsx05: ['#AC362B', '#FD8475', '#F5F5F5', '#30B7CE', '#006699'],
        colorsx06: ['#AC362B', '#F25D4A', '#FAADA3', '#78CEDC', '#009CBC', '#006699'],
        colorsx07: ['#AC362B', '#F25D4A', '#FAADA3', '#F5F5F5', '#78CEDC', '#009CBC', '#006699'],
        colorsx08: ['#7A1A14', '#B93D30', '#FB624E', '#FAB2A9', '#81D0DE', '#00A3C1', '#0070A0', '#003F80'],
        colorsx09: ['#7A1A14', '#B93D30', '#FB624E', '#FAB2A9', '#F5F5F5', '#81D0DE', '#00A3C1', '#0070A0', '#003F80'],
        colorsx10: ['#7a1a14', '#AC362B', '#E05342', '#FD8475', '#F9C0B9', '#99D8E3', '#30B7CE', '#008FB4', '#006699', '#003f80'],
        colorsx11: ['#7a1a14', '#ac362b', '#e05342', '#fd8475', '#f9c0b9', '#f5f5f5', '#99D8E3', '#30B7CE', '#008FB4', '#006699', '#003f80'],
    },
    bivariateColors: {
        colors04x04: [
            ['#D1D7D8', '#D6CAA7', '#D9BE71', '#DEB029'],
            ['#92BBD4', '#95AFA3', '#98A66F', '#9B9929'],
            ['#4D9ECF', '#4F94A0', '#508C6C', '#528228'],
            ['#007CC9', '#00749B', '#006E69', '#006539'],
        ],
        colors05x04: [
            ['#DAE0E2', '#DFD3AE', '#E4C776', '#E8B82B'],
            ['#A8CADE', '#ACBFAB', '#B0B474', '#B3A62B'],
            ['#76B4DA', '#78A9A8', '#7BA072', '#7D942A'],
            ['#3D9DD7', '#3E93A5', '#408B70', '#418029'],
            ['#0081D6', '#007AA5', '#00736F', '#006A29'],
        ],
        colors04x05: [
            ['#DAE0E2', '#DED7B8', '#E1CE89', '#E6C358', '#E8B82B'],
            ['#99C3DD', '#9BBBB4', '#9DB387', '#A0AA57', '#A2A02A'],
            ['#51A5D8', '#529EB0', '#539884', '#559055', '#568729'],
            ['#0081D6', '#007CAE', '#007782', '#007154', '#006A29'],
        ],
        colors05x05: [
            ['#DAE0E2', '#DED7B8', '#E1CE89', '#E6C358', '#E8B82B'],
            ['#A8CADE', '#ABC2B4', '#ADBA87', '#B1B057', '#B3A62B'],
            ['#76B4DA', '#78ACB1', '#79A685', '#7C9D56', '#7D942A'],
            ['#3D9DD7', '#3E96AE', '#3F9083', '#408854', '#418029'],
            ['#0081D6', '#007CAE', '#007782', '#007154', '#006A29'],
        ],
    },
    sdgColors: {
        sdg1: '#E5243B',
        sdg2: '#DDA63A',
        sdg3: '#4C9F38',
        sdg4: '#C5192D',
        sdg5: '#FF3A21',
        sdg6: '#26BDE2',
        sdg7: '#FCC30B',
        sdg8: '#A21942',
        sdg9: '#FD6925',
        sdg10: '#DD1367',
        sdg11: '#FD9D24',
        sdg12: '#BF8B2E',
        sdg13: '#3F7E44',
        sdg14: '#0A97D9',
        sdg15: '#56C02B',
        sdg16: '#00689D',
        sdg17: '#19486A',
    }
};
module.exports = UNDPColorModule;
